<app-dialog
  [title]="data.type === 'New' ? 'New Warehouse' : 'Update Warehouse'"
  [actions]="[
    { text: 'Cancel', buttonStyle: 'underline' },
    {
      text: data.type === 'New' ? 'Save' : 'Update',spin: spin,
      isDisabled: this.warehouseForm.invalid
    }
  ]"
  (action)="dialogAction($event)"
  (close)="dialogRef.close()"
  class="edit_ware_block"
>
  <mat-dialog-content>
    <form [formGroup]="warehouseForm" autocomplete="off" class="form">
      <div class="input-container">
        <label for="" class="input-container_label"
          >Name your Warehouse: <span class="input-container_asterisk">*</span></label
        >
        <input
          class="input-container_input"
          type="text"
          formControlName="Id"
          (keyup)="checkId($event)"
          [readonly]="data.type === 'edit'"
        />
        <i
          class="fal fa-check primary_color"
          *ngIf="uniqueId && checkedUniqueId"
        ></i>
        <i
          class="fal fa-times danger_color"
          *ngIf="!uniqueId && checkedUniqueId && !loadingUniqueId"
        ></i>
        <i
          class="fal fa-sync fa-spin primary_color"
          *ngIf="loadingUniqueId"
        ></i>
        <small *ngIf="!uniqueId && checkedUniqueId" class="danger_color"
          >Warehouse name is not available</small
        >
      </div>
      <div class="input-container">
        <label class="input-container_label" for=""
          >Company Name: <span class="input-container_asterisk">*</span></label
        >
        <input
          class="input-container_input"
          type="text"
          formControlName="Name"
        />
      </div>
      <div class="input-container" >
        <label class="input-container_label" for=""
          >Address<span class="input-container_asterisk">*</span></label
        >
        <input
          class="input-container_input"
          type="text"
          formControlName="Addressln1"
          #addressText
        />
      </div>
      
      <div class="input-container">
        <label class="input-container_label" for="">Address Line #2:</label>
        <input
          class="input-container_input"
          type="text"
          formControlName="Addressln2"
        />
      </div>
      
      
      <ng-container >   


        <div class="input-container">
          <label class="input-container_label" for=""
            >City:<span class="input-container_asterisk">*</span></label
          >
          <input
            class="input-container_input"
            type="text"
            formControlName="City"
          />
        </div>

      

      <div class="input-container">
        <label class="input-container_label" for=""
          >State:<span class="input-container_asterisk">*</span></label
        >
        <input
          class="input-container_input"
          type="text"
          formControlName="State"
          autocomplete="one-time-code"
        />
      </div>  
      
      

      <div class="input-container">
        <label class="input-container_label"
          >Zip:<span class="input-container_asterisk">*</span></label
        >
        <input
          class="input-container_input"
          numbersOnly
          formControlName="Postal"
        />
      </div>

      <div class="input-container">
        <label class="input-container_label" for=""
          >Country Code:<span class="input-container_asterisk">*</span></label
        >
        <input
          class="input-container_input"
          type="text"
          formControlName="CountryCode"
          autocomplete="one-time-code"
        />
      </div>

    </ng-container>
    <div class="input-container">
      <label for="" class="input-container_label">Priority Level  <i class="input-container--fa-info-circle fas fa-info-circle" 
        matTooltip="prioritize warehouses for deduct FBM orders"
       ></i></label>
      <input type="number" class="input-container_input" formControlName="Priority" min="1" />
    </div>

    <div class="d-flex align-items-center gap-4" style="grid-column: span 2 / span 2;">
      <div class="input-container gap_top_1pt5" *ngIf="userInfo.isPlanYard">
        <div class="checkbox switcher">
          <label for="toggleisCarriesInventory">
            <input type="checkbox" id="toggleisCarriesInventory" value="" formControlName="IsCarriesInventory" [attr.disabled]="data.isInventoryAdded ? true : null">
            <span [matTooltip]="data.isInventoryAdded ? 'we can not turn it off because it has inventory' : '' "><small></small></span>
            <span class="toggle-label">Carries Inventory</span>
          </label>
        </div>
      </div>
  
      <div class="input-container gap_top_1pt5">
        <div class="checkbox switcher">
          <label for="toggleFBA">
            <input type="checkbox" id="toggleFBA" value="" formControlName="Isfbm">
            <span><small></small></span>
            <span class="toggle-label">Fulfills FBM</span>
            <i class="input-container--fa-info-circle fas fa-info-circle" 
                 matTooltip="enables to use stock from this warehouse for merchant items, including sync/deduct stock, and batch/pick/ship merchant orders"
                ></i>
          </label>
        </div>
      </div>
    </div>

    </form>
  </mat-dialog-content>
</app-dialog>
